const metrics = {};

metrics.percentage = (value, total) => {
  if (total === 0) {
    return 0;
  }
  return ((value / total) * 100).toFixed(1);
};

export default metrics;



// WEBPACK FOOTER //
// ./src/helpers/metrics.js